import { PostWithUser } from "../../types/index.type";
import { ActivityStats } from "./activity";
import { Attachments } from "./attachments";
import { DuoThought } from "./duothought";
import { ActionButtons } from "./actions";
import { PostMeta } from "./post-meta";
import { UserInfo } from "./post-user-info";
import { Reactions } from "./reactions";

// Post Card Component
type PostCardProps = {
  post: PostWithUser["post"];
  user: PostWithUser["user"];
};

export const PostCard = ({ post, user }: PostCardProps) => {
  return (
    <div className="group relative overflow-hidden border-0 shadow-sm hover:shadow-lg transition-all duration-300 bg-white/50 backdrop-blur-sm rounded-lg border bg-white text-gray-900">
      {/* Subtle gradient border effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 via-purple-500/10 to-pink-500/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      <div className="flex flex-col space-y-2 p-4 border-b relative pb-4">
        <div className="flex items-start justify-between">
          <div className="flex-1 space-y-3">
            {/* User Info Row */}
            <UserInfo user={user} post={post} />

            {/* Post Meta Row */}
            <PostMeta post={post} />
          </div>

          {/* Action Buttons */}
          <ActionButtons userId={post.userId} postId={post.id} />
        </div>
      </div>

      <div className="p-4 relative space-y-5">
        {/* Post Content */}
        <div className="prose prose-sm max-w-none">
          <p className="text-gray-700 leading-relaxed">{post.content}</p>
        </div>

        {/* Activity Stats */}
        {post.type === "ACTIVITY" && <ActivityStats activity={post.activity} />}

        {/* Duo Thought */}
        {post.type === "DUO_THOUGHT" && <DuoThought partner={post.partner} />}

        {/* Attachments */}
        <Attachments attachments={post.attachments} />

        {/* Reactions */}
        <Reactions vibeCounts={post.vibeCounts} />
      </div>
    </div>
  );
};
